// 主题配置文件
export const themeColors = [
  {
    name: '默认蓝',
    primary: '#007AFF',
    secondary: '#00c6fb',
    gradient: 'linear-gradient(135deg, #0070f3 0%, #00c6fb 100%)'
  },
  {
    name: '活力橙',
    primary: '#FF9500',
    secondary: '#FF5E3A',
    gradient: 'linear-gradient(135deg, #FF9500 0%, #FF5E3A 100%)'
  },
  {
    name: '清新绿',
    primary: '#34C759',
    secondary: '#00B894',
    gradient: 'linear-gradient(135deg, #34C759 0%, #00B894 100%)'
  },
  {
    name: '优雅紫',
    primary: '#AF52DE',
    secondary: '#9B59B6',
    gradient: 'linear-gradient(135deg, #AF52DE 0%, #9B59B6 100%)'
  },
  {
    name: '沉稳灰',
    primary: '#8E8E93',
    secondary: '#636E72',
    gradient: 'linear-gradient(135deg, #8E8E93 0%, #636E72 100%)'
  }
]